

import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  root: {
    maxWidth: 775,
  }
});

class SearchBanner extends Component {

  constructor(props) {
    super(props);

    this.state = {
      banner: this.props.banner,
      textSearched: false
    };
  }

  componentDidMount() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const query = urlParams.get('q');

    if (query !== "" && query !== undefined && query != null) {
      this.setState({ textSearched: true });
    }
  }

  componentDidUpdate() {
    const { textSearched } = this.state;

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const query = urlParams.get('q');

    if (query !== "" && query !== undefined && query !== null) {
      if (!textSearched) {
        this.setState({ textSearched: true });
      }
    }
    else {
      if (textSearched) {
        this.setState({ textSearched: false });
      }
    }
  }

  render() {
    const { banner, textSearched } = this.state;
    const { classes } = this.props;

    return (
      <>
        {banner !== '' && !textSearched &&
          <Card className={`${classes.root} bannerText`}>
            <CardActionArea> 
              <CardMedia
                component="img"
                className={classes.media}
                height="auto"
                image={banner}
                title="Search Banner"
              />
            </CardActionArea>
          </Card>
        }
      </>
    );
  }
}

export default withStyles(styles)(SearchBanner);